import { blue, grey } from "@mui/material/colors";

const styles = {
  root: {
    position: "relative",
  },
  container: (tabOpen: boolean) => ({
    // 95vh added some space at the bottom for the Bulk Actions menu.
    maxHeight: {
      xs: "calc(95vh - 292px)",
      md: tabOpen ? "calc(95vh - 242px)" : "calc(100vh - 205px)",
      lg: "calc(95vh - 205px)",
    },
    overflow: "auto",
    position: "relative",
  }),
  table: {
    borderLeft: `1px solid ${grey[300]}`,
  },
  snippet: {
    fontSize: 12,
    color: grey[700],
    width: 300,
    overflow: "hidden",
  },
  subject: {
    color: "black",
    mr: 0.5,
  },
  header: {
    position: "relative",
    zIndex: 201,
  },
  tableRow: (isNewRow: boolean) => ({
    backgroundColor: "white",
    "&:nth-last-of-type(2) td": { borderBottom: 0 },
    ...(isNewRow && { position: "sticky", bottom: "44px", zIndex: 200 }),
  }),
  info: {
    color: "info.main",
    textDecoration: "none",
    mb: 4,
    cursor: "pointer",
  },

  fetchMoreLoader: {
    position: "absolute",
    left: "50%",
    transform: "translate(-50%)",
    bottom: "12px",
    fontSize: 12,
    zIndex: 249,
    display: "flex",
    alignItems: "center",
  },
  highlightedNewRow: {
    backgroundColor: `${blue[50]}`,
  },
  totalRows: {
    position: "absolute",
    right: "75px",
    bottom: "8px",
    zIndex: 300,
    fontSize: 12,
    color: grey[800],
  },
};

export default styles;
